import axios from "axios";
import {baseUrl} from "../../utils/baseurl";

export const getProTips = () => {
    const GET_PRO_TIPS_ENDPOINT = baseUrl('pro-tips/');
    const config = {
        method: 'GET',
        url: GET_PRO_TIPS_ENDPOINT,
        withCredentials: true,
        xsrfCookieName: 'csrftoken',
        xsrfHeaderName: 'X-CSRFToken',
        withXSRFToken: true,
    };
    return axios.request(config)
        .then(response => {
            return response;
        }).catch(error => {
            return error;
        });
};
